import { get } from 'common/utils/request';
export var fetchAdditionalInfoApi = function () {
    return get('/companies/self/additional-info');
};
